<div class="content">
  <div class="form-login">
    <div class="main-title"><span>
      <a href="/">SatPhoneRecharge</a>
      <br/>
      potwierdzenie zamówienia
    </span></div>
    <hr class="dashed-line">
    <div *ngIf="purchase.statusCode == 0">
      <h2>Trwa weryfikacja...</h2>
    </div>

    <div *ngIf="purchase.statusCode >0 && purchase.statusCode != 200">
      <h2>Zamówienie niepotwierdzone, skontaktuj się z operatorem</h2>
    </div>

    <div *ngIf="purchase.statusCode == 200">
      <h2>Dane zamówienia</h2>
      <form>
        <div class="input-control">
          <label for="refCode">Kod referencyjny</label>
          <input formControlName="refNumber" id="refNumber" maxlength="150" readonly type="text"
                 value="{{ purchase.refNumber }}"/>
        </div>
      </form>
    </div>

    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
